import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link,useLocation } from "react-router-dom";

function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) return value;
  }
  return null;
}

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);
const [clicked, setClicked] = useState(false);

  const [error, setError] = useState(null);
  const opt = getCookie('opt');
  const user = getCookie('user');
   const isStaff = getCookie('isStaff') === "true";

const secretId = getCookie('secretId');
const handleSearchSubmit = (e) => {
  e.preventDefault();
  // console.log("Form submitted"); 
  // console.log("Search Term:", searchTerm);
  if (searchTerm.trim() !== "") {
    navigate("/allCustomer/all", { state: { customerId: searchTerm } });
  }
   
};
const fetchUserData = async () => {
  try {
    let payload;

    if (isStaff === true && secretId) {
      // 🔥 Staff → send both
      payload = {
        user,
        secretId
      };
    } else {
      // 🔥 Admin → only user
      payload = {
        user
      };
    }

    const response = await axios.post(
      'https://node.cabletvpay.in/home',
      payload
    );

    if (response.status === 200) {
      setData(response.data.message);
    }
  } catch (err) {
    setError(err.response?.data?.message || "Error fetching data");
    console.log(err);
  } finally {
    setLoading(false);
  }
};
   {loading ? (
  <RotatingLines width="25" strokeColor="rgb(189, 28, 28)" />
) : (
  <Link
    to="/walletamount"
    className="bg-warning"
  >
    Payable Amount | {(data?.walletCount ?? 0).toLocaleString()}
  </Link>
)}
useEffect(() => {
  // 🔥 whenever navigation state changes → clear search
  if (location.state?.customerId) {
    setSearchTerm("");
 
  }
}, [location.state]);

 useEffect(() => {
      fetchUserData();
     
    }, []); // Empty dependency array ensures this runs only once
  return (
    <nav className="main-header navbar elevation-2 navbar-expand bg-light">
   <ul className="navbar-nav flex-column flex-lg-row">
  <li className="nav-item mx-2">
    <a
      className="nav-link px-0 px-lg-2"
      data-widget="pushmenu"
      href="#"
      role="button"
      onClick={(e) => e.preventDefault()}
    >
      <i className="fas fa-bars text-navy" />
    </a>
  </li>

  <li className="nav-item order-2 order-lg-2 w-100 my-2">
<form onSubmit={handleSearchSubmit} className="w-100">
  <div className="input-group elevation-2 rounded border-dark w-100">

      <input
        className="form-control border-navy bg-white"
        id="serial_num"
        name="serial_num"
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setClicked(false);
        }}
      />

      <button
        type="submit"
        onClick={() => setClicked(true)}
        className={`btn border-0 ${
          clicked ? "btn-success" : "bg-gradient-navy text-light"
        }`}
      >
        Go
      </button>
    </div>
  </form>
</li>


  <li className="nav-link text-center text-lg-start">
    <span className="h5 text-orange">{opt}</span>
  </li>
</ul>

<div className="col-lg-4 col-sm-4 py-lg-0 py-1">
  <div className="d-flex justify-content-center">
    {loading ? (
      <RotatingLines width="25" strokeColor="#002040" />
    ) : (
 <Link
  to="/walletamount"
  className="btn payable-gradient border-0"
>
  Payable Amount | {(data?.walletCount ?? 0).toLocaleString()}
</Link>


    )}
  </div>


</div>

      <ul className="navbar-nav ms-auto">
        <li className="nav-item">
          <Link className="nav-link btn bg-gradient-danger text-white p-1 py-2" to="/login">
            LogOut
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
